import { StatusView } from "@/types/api";

export const MONETA_API_BASE_URL = process.env.REACT_APP_MONETA_API_BASE_URL;
export const APP_BASIC_AUTH_TOKEN = process.env.REACT_APP_BASIC_AUTH_TOKEN;
export const BASIC_AUTH_TOKEN = `Basic ${APP_BASIC_AUTH_TOKEN}`;
export const MONETA_GRAPHQL_URL = `${MONETA_API_BASE_URL}/graphql`;

export type TimeZone = {
  name: string;
  value: string;
};

export const TIME_ZONES: TimeZone[] = [
  { name: "Pacific Time", value: "America/Los_Angeles" },
  { name: "Arizona", value: "America/Phoenix" },
  { name: "Mountain Time", value: "America/Boise" },
  { name: "Central Time", value: "America/Chicago" },
  { name: "Eastern Time", value: "America/New_York" },
  { name: "Alaska", value: "America/Anchorage" },
];

export const timeZoneConverted = (timeZoneValue?: string) => {
  const timeZone = TIME_ZONES.find((timeZone) => timeZone.value === timeZoneValue);
  return timeZone?.name ?? "Eastern Time";
};

export type StatusType = {
  name: string;
  value: StatusView;
};

export const ACTIVITY_STATUS: StatusType[] = [
  { name: "Active", value: StatusView.Active },
  { name: "Deleted", value: StatusView.Deleted },
  { name: "All", value: StatusView.All },
];
